import { call, put } from 'redux-saga/effects';
import { CustomersService } from '../../../services/Customers';
import { addNewContractNotifications } from '../notifications/actions';
import {
  ENotificationTypes,
  INewContractNotification
} from '../notifications/types';
import { IUser } from '../user/types';
import {
  loadCustomersSuccess,
  loadCustomersFailure,
  loadCustomersProductDescriptionSuccess,
  loadCustomersProductDescriptionFailure,
  loadCustomerBlocksSuccess,
  loadCustomerBlocksFailure,
  loadCustomerFromIdFailure,
  loadCustomerPurchaseReceiversSuccess,
  loadCustomerPurchaseReceiversFailure,
  loadCustomerFromIdSuccess
} from './actions';
import {
  IBlock,
  IPurchaseReceiver,
  ICustomer,
  IProductDescriptionResponse
} from './types';
import { addToast } from '../toast/actions';
import { EToastTypes } from '../toast/types';

interface ICustomerSagaParams {
  payload: {
    selectedCustomerId: string;
    flag: boolean;
    user: IUser;
  };
}

export function* loadCustomersSaga(params: ICustomerSagaParams) {
  try {
    const { user } = params.payload;
    const customersService = new CustomersService();
    const customers: ICustomer[] = yield call(
      customersService.getCustomers.bind(customersService, user)
    );

    yield put(loadCustomersSuccess(customers));
    yield call(checkForNewContracts, customers, user);
  } catch (err) {
    console.error('loadCustomers', err);
    yield put(loadCustomersFailure(err));
  }
}

export function* loadCustomerFromIdSaga(params: ICustomerSagaParams) {
  try {
    const { selectedCustomerId } = params.payload;
    const customersService = new CustomersService();
    const customer: ICustomer = yield customersService.getCustomerById(
      selectedCustomerId
    );
    yield put(loadCustomerFromIdSuccess(customer));
  } catch (err) {
    console.error('loadCustomerFromIdSaga', err);
    yield put(loadCustomerFromIdFailure(err));
  }
}

function* checkForNewContracts(customers: ICustomer[], user: IUser) {
  const customersThatUserHasFabricationContractsAccess = customers.filter(
    (customer) =>
      user.roles.ordersInputCustomers.includes(customer.customerId) &&
      user.roles.fabricationViewCustomers?.includes(customer.customerId)
  );

  const hasNewContractsCustomers =
    customersThatUserHasFabricationContractsAccess.filter(
      (customer) => customer.hasNewContracts === true
    );

  const newContractNotifications: INewContractNotification[] =
    hasNewContractsCustomers.map((customer) => {
      return {
        customerId: customer.customerId,
        title: `${customer.name} - ${customer.customerId}`,
        type: ENotificationTypes.NEW_CONTRACT
      };
    });

  if (newContractNotifications.length > 0) {
    try {
      yield put(addNewContractNotifications(newContractNotifications));
    } catch (err) {
      console.error('checkForNewContracts', err);
    }
  }
}

export function* loadCustomersProductDescription(params: ICustomerSagaParams) {
  try {
    const { selectedCustomerId } = params.payload;
    const customersService = new CustomersService();
    const productsDescriptionResponse: IProductDescriptionResponse =
      yield customersService.getProductDescriptions(selectedCustomerId);
    yield put(
      loadCustomersProductDescriptionSuccess(
        productsDescriptionResponse,
        selectedCustomerId
      )
    );
  } catch (err) {
    console.error('loadCustomersProductDescription', err);
    yield put(loadCustomersProductDescriptionFailure(err));
  }
}

export function* loadCustomersProductDescriptionV2(
  params: ICustomerSagaParams
) {
  try {
    const { selectedCustomerId } = params.payload;
    const customersService = new CustomersService();
    const productsDescriptionResponse: IProductDescriptionResponse =
      yield customersService.getProductDescriptionsV2(selectedCustomerId);
    yield put(
      loadCustomersProductDescriptionSuccess(
        productsDescriptionResponse,
        selectedCustomerId
      )
    );
  } catch (err) {
    console.error('loadCustomersProductDescription', err);
    yield put(loadCustomersProductDescriptionFailure(err));
  }
}

export function* loadCustomerBlocks(params: ICustomerSagaParams) {
  try {
    const { selectedCustomerId } = params.payload;
    const customersService = new CustomersService();
    const customerBlocks: IBlock[] = yield customersService.getCustomerBlocks(
      selectedCustomerId
    );
    yield put(loadCustomerBlocksSuccess(customerBlocks, selectedCustomerId));
  } catch (err) {
    console.error('loadCustomerBlocks', err);
    yield put(loadCustomerBlocksFailure(err));
  }
}

export function* loadCustomerPurchaseReceiversSaga(
  params: ICustomerSagaParams
) {
  try {
    const { selectedCustomerId } = params.payload;
    const customersService = new CustomersService();
    const receivers: IPurchaseReceiver[] =
      yield customersService.getCustomerPurchaseReceivers(selectedCustomerId);
    yield put(
      loadCustomerPurchaseReceiversSuccess(receivers, selectedCustomerId)
    );
  } catch (err) {
    console.error('loadCustomerBlocks', err);

    yield put(
      addToast({
        type: EToastTypes.DANGER,
        message: 'Falha ao carregar os recebedores.'
      })
    );
    yield put(loadCustomerPurchaseReceiversFailure(err));
  }
}
